// extracted by mini-css-extract-plugin
module.exports = {"modal":"ReviewItem_modal__r80YO","modal-content":"ReviewItem_modal-content__S0Y6V","review":"ReviewItem_review__kUNEC"};